import { Activity } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, MetricChart, Panel, ServerCard, AsyncBoundary, CardSkeleton } from "@/components/common";

export default function Monitoring() {
  const { data, loading, error } = useAsync(() =>
    Promise.all([api.getInfraUsage(), api.getServers()]).then(([usage, servers]) => ({ usage, servers })), [], 20000);
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={Activity} title="Monitoramento" description="Métricas agregadas da infraestrutura. Snapshots reais do Agent; histórico ainda não implementado."
        breadcrumb={<><span>Infraestrutura</span><span>/</span><span className="text-foreground">Monitoramento</span></>}
         />
      <AsyncBoundary loading={loading} error={error} skeleton={<CardSkeleton />}>
        {data && (
          <>
            <Panel title="Uso Global da Infraestrutura" icon={Activity}><MetricChart dataByRange={data.usage} height={320} /></Panel>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              {data.servers.map((s) => <ServerCard key={s.id} server={s} />)}
            </div>
          </>
        )}
      </AsyncBoundary>
    </div>
  );
}
